const PALETTE = [
  { bg: "rgba(16,185,129,0.15)", text: "#34d399", border: "rgba(16,185,129,0.25)" },
  { bg: "rgba(59,130,246,0.15)", text: "#60a5fa", border: "rgba(59,130,246,0.25)" },
  { bg: "rgba(239,68,68,0.15)", text: "#f87171", border: "rgba(239,68,68,0.25)" },
  { bg: "rgba(245,158,11,0.15)", text: "#fbbf24", border: "rgba(245,158,11,0.25)" },
  { bg: "rgba(168,85,247,0.15)", text: "#c084fc", border: "rgba(168,85,247,0.25)" },
  { bg: "rgba(236,72,153,0.15)", text: "#f472b6", border: "rgba(236,72,153,0.25)" },
  { bg: "rgba(14,165,233,0.15)", text: "#38bdf8", border: "rgba(14,165,233,0.25)" },
];

const OFF_COLOR = { bg: "rgba(148,163,184,0.2)", text: "#94a3b8", border: "rgba(148,163,184,0.3)" };

export const getShiftColor = (idx, name = "") => {
  if (name && (name.toLowerCase() === "off" || name.toLowerCase().includes("week off"))) {
    return OFF_COLOR;
  }
  return PALETTE[idx % PALETTE.length];
};

export const buildShiftColorMap = (shifts = []) => {
  const map = {};
  shifts.forEach((s, i) => {
    map[s.id] = getShiftColor(i, s.name);
    map[s.name] = getShiftColor(i, s.name);
  });
  map.Off = OFF_COLOR;
  return map;
};
